import React, { useEffect, useState } from 'react';
import imageKirbySrc from './images/image-kirby.png'
import imagePuddingSrc from './images/image-pudding.png'
import imageTenkaanSrc from './images/image-tenkaan.png'
import imageTenkaan2Src from './images/image-tenkaan-2.png'
import imageMelon from './images/fruit_melon.png'

const isTenka = /[=\/]tenkaan/.test(window.location.href)
const IMAGE_1 = isTenka ? imageTenkaanSrc : imageKirbySrc
const IMAGE_2 = isTenka ? imageTenkaan2Src : imagePuddingSrc
const IMAGE_LOADING = isTenka ? imageMelon : imageKirbySrc
const NAME = isTenka ? '甜瓜あん‍' : 'カービィ'
const UNIT = isTenka ? '人' : '匹'
document.title = `${NAME}描画`

function App() {
  const [count, setCount] = useState(50)
  const [dataUrl, setDataUrl] = useState('')
  const isLoading = dataUrl === ''

  const getIllust = (src: string): Promise<HTMLImageElement> => {
    const illust = new Image()
    illust.src = src
    return new Promise(resolve => illust.onload = () => resolve(illust))
  }

  const generate = async () => {
    setDataUrl('')
    const isMobile = window.innerWidth < 500

    const xMaxCount = isMobile ? 85 : Infinity
    const xCount = Math.min(Math.ceil(Math.sqrt(count)), xMaxCount)
    const yCount = Math.ceil(count / xCount)

    const canvasWidth = window.innerWidth * (isMobile ? 2 : 3)
    const canvasHeight = canvasWidth * (yCount / xCount)

    const imageWidth = canvasWidth / xCount
    const imageHeight = imageWidth // 画像は正方形とする

    const imageKirby = await getIllust(IMAGE_1)
    const imagePudding = await getIllust(IMAGE_2)

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    let randomPuddingIndex = -1
    if (count >= 100) {
      // 100匹以上の場合はランダムでどこかにプリンを表示
      randomPuddingIndex = ~~(Math.random() * count)
    }

    canvas.width = canvasWidth
    canvas.height = canvasHeight

    if (ctx) {
      for(let i = 0; i < count; i++) {
        const x = (i % xCount) * imageWidth
        const y = (~~(i / xCount)) * imageHeight
        const isPudding = i === randomPuddingIndex
        ctx.drawImage(
          isPudding ? imagePudding : imageKirby,
          x, y, imageWidth, imageHeight
        )
      }
    }
    setDataUrl(canvas.toDataURL())
  }
  useEffect(() => {
    generate()
  }, [])
  return (
    <div className="App">
      <h1>{NAME}描画</h1>
      <p className="description">入力した数だけ{NAME}を描画する</p>
      <input
        type="number"
        value={count}
        className="inputCount"
        onChange={
          (e) => setCount(~~e.target.value)
        }
      />{UNIT}
      {isLoading ? (
        <p className="loading">
          <i><img src={IMAGE_LOADING} alt=""/></i><br/>
          読み込み中
        </p>
      ) : (
        <p>
          <button onClick={generate}>描画</button>
        </p>
      )}
      <br/>

      <img src={dataUrl} width="100%" alt=""/>
    </div>
  )
}

export default App
